// extracted by mini-css-extract-plugin
export default {"modal":"modal___QNp8p","header":"header___VhpgT","mask":"mask___RtAKv","icon":"icon___DyjoG","content":"content___kPtbc"};